import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { CustomError } from "@orthofi/ngx-error-handler";
import { InsurancePolicy } from "./insurance-policy";

export const changeAssignmentOfBenefitSuccess = createAction(
  "[Insurance API] Change AOB Success"
);

/**
 * Signal that the API call for the creation of an insurance policy was 
 * successful.
 */
export const createInsurancePolicySuccess = createAction(
  '[InsurancePolicy/API] Create Insurance Policy Success',
  props<{
    benefit: number,
    id: number,
    insurancePolicy: InsurancePolicy
    treatmentPlanId: number,
  }>()
);

/** Signal that the API call for the creation of an insurance policy failed. */
export const createInsurancePolicyFail = createAction(
  '[InsurancePolicy/API] Create Insurance Policy Failed',
  props<{ error: Error | HttpErrorResponse | CustomError }>()
);

/**
 * Signal that the API call for the removal of an insurance policy was
 * successful.
 */
export const removeInsurancePolicySuccess = createAction(
  '[InsurancePolicy/API] Delete Insurance Policy Success',
  props<{ id: number }>()
);

/** Signal that the API call for the removal of an insurance policy failed. */
export const removeInsurancePolicyFail = createAction(
  '[InsurancePolicy/API] Delete Insurance Policy Failed',
  props<{ error: Error | HttpErrorResponse | CustomError }>()
);